module.exports = __webpack_public_path__ + "img/telecomunicaciones.c70a6a58.png";